<template>
  <v-content style="background-color: #F8F8F8;margin-bottom: 8rem">
    <!-- Sub Slide Group Desktop -->
    <v-layout class="justify-center" v-if="$vuetify.breakpoint.mdAndUp">
      <v-flex xs12 v-if="category_id != 0">
        <v-layout wrap class="my-6" style="background-color: #F8F8F8">
          <v-flex
            class="shrink on-hover-cate mr-3 mb-2 d-flex align-center justify-center"
            @click="onclickSubCategoryAll"
            :class="subCateId == 0 ? 'active-category' : ''"
          >
            <div>
              <v-btn
                v-if="subCateId == 0"
                width="100%"
                height="100%"
                outlined
                color="#FD5246"
              >
                <span>{{ $t("all") }}</span>
              </v-btn>
              <span v-if="subCateId != 0">{{ $t("all") }}</span>
            </div>
          </v-flex>
          <v-flex
            shrink
            class="text-center on-hover-cate d-flex justify-center align-center mr-3 mb-2"
            v-for="(subCate, i) in subCategoryLists"
            :key="i"
            @click="onClickSubCate(subCate)"
          >
            <div
              class="d-flex justify-center align-center"
              v-if="subCate.count_port > 0"
            >
              <v-btn
                v-if="subCateId == subCate.id"
                width="100%"
                height="100%"
                outlined
                large
                color="#FD5246"
              >
                <span
                  >{{
                    switchLanguage === "th" ? subCate.name_th : subCate.name_en
                  }}
                  ({{ subCate.count_port }})</span
                >
              </v-btn>
              <span v-if="subCateId != subCate.id">
                {{
                  switchLanguage === "th" ? subCate.name_th : subCate.name_en
                }}
                ({{ subCate.count_port }})
              </span>
              <v-divider
                class="ml-2"
                v-if="subCateId != subCate.id"
                vertical
              ></v-divider>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Sub Slide Group Mobile -->
    <v-layout v-else class="px-3">
      <v-flex v-if="category_id != 0 && subCategoryLists.length > 0">
        <v-autocomplete
          hide-details
          placeholder="หมวดหมู่ย่อย"
          color="#FD5246"
          outlined
          dense
          flat
          menu-props="offset-y"
          :items="subCategoryLists"
          item-value="id"
          :item-text="$i18n.locale === 'th' ? 'name_th' : 'name_en'"
          @change="onClickSubCate"
          return-object
        >
          <template slot="item" slot-scope="{ item }">
            {{ $i18n.locale === "th" ? item.name_th : item.name_en }} ({{
              item.count_port
            }})
          </template>
        </v-autocomplete>
      </v-flex>
    </v-layout>

    <!-- แสดง UI ของหมวดหมู่ต่างๆ -->
    <v-layout v-if="category_id != 0">
      <v-flex>
        <!-- Content -->
        <v-container fluid>
          <v-row>
            <v-col
              v-for="card in portfolioArticles.data"
              :key="card.id"
              :cols="
                $vuetify.breakpoint.lgAndUp
                  ? 2
                  : '' || $vuetify.breakpoint.md
                  ? 3
                  : '' || $vuetify.breakpoint.sm
                  ? 6
                  : '' || $vuetify.breakpoint.xs
                  ? 12
                  : ''
              "
              @click="viewPortDetail(card)"
            >
              <card-content
                font-lg="12"
                width="318"
                height="100%"
                :image-cover="card.cover_img_path"
                :title="card.project_title"
                :by="card.profile"
                :image-profile="
                  card.profile ? checkImage(card.profile.mem_info) : ''
                "
              ></card-content>
            </v-col>
          </v-row>
        </v-container>

        <v-layout
          class="justify-center mb-6 mt-4"
          v-if="
            count_item > 12 &&
              portfolioArticles.current_page < portfolioArticles.last_page
          "
        >
          <v-flex shrink>
            <v-btn
              :loading="btnLoading"
              v-if="checkBtn === true"
              width="150"
              outlined
              color="#FD5246"
              @click="getPortfolioByIdCategoryMore"
            >
              <span>{{ $t("more") }}</span>
            </v-btn>
            <v-btn
              :loading="btnLoading"
              v-if="checkBtn === false"
              width="150"
              outlined
              color="#FD5246"
              @click="getPortfolioByIdSubCategoryMore"
            >
              <span>{{ $t("more") }}</span>
            </v-btn>
          </v-flex>
        </v-layout>

        <v-layout
          v-if="portfolioArticles.data.length === 0"
          style="padding-bottom: 29rem"
        >
          <v-flex class="text-center">
            <span style="color: #5d5d5d">{{ $t("status-not-fount") }}</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- แสดง UI ของหมวดหมู่รวม -->
    <v-layout v-else>
      <v-flex>
        <v-layout class="justify-space-around mt-4 mb-10 px-6">
          <v-flex class="xs12">
            <v-divider style="border: 0.5px solid #C4C4C4;"></v-divider>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-space-between>
          <v-flex
            class="lg6 md12 sm12  xs12 mb-12 px-6"
            v-for="(item, index) in groupCategory"
            :key="index"
          >
            <SlideCategoryGroup
              v-if="item.portfolioCategory.length > 0"
              :cateId="item.id"
              :totalPortfolio="item.totalPortfolio"
              :onClickCategory="onclickCategory"
              :textBtn="item.name_th"
              :iconBtn="item.name_en"
              :colorBtn="item.id"
              :portfolios="item.portfolioCategory"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
  </v-content>
</template>

<script>
import CardContent from "../../components/card_content/CardContent";
import SlideCategoryGroup from "../../components/slide_group/SlideCategoryGroup";
import { mapState } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { domain, imgPath } from "../../services/Constants";

export default {
  name: "AllPortfolioByCategory",
  components: {
    CardContent,
    Loading,
    SlideCategoryGroup,
  },
  data: () => ({
    imgPath: imgPath,
    url: domain,
    btnLoading: false,
    isLoading: false,
    fullPage: true,
    portfolios: [],
    subCates: [],
    subCateId: 0,
    groupCategory: [],
    category_id: 0,
  }),
  computed: {
    ...mapState({
      portfolioArticles: (state) => {
        return state.portfolio.portfolio_categorys.portfolios;
      },
      // category_id: (state) => {
      //   return state.portfolio.portfolio_categorys.category_id;
      // },
      checkBtn: (state) => {
        return state.portfolio.checkBtn;
      },
      count_item: (state) => {
        return state.portfolio.count_item;
      },
      subCategoryLists: (state) => {
        return state.portfolio.portfolio_categorys.subCategoryLists;
      },
      // subcategory_id: (state) => {
      //   return state.portfolio.portfolio_categorys.subcategory_id;
      // },
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
    }),
    onChangeCate() {
      return this.$route.params.slug;
    },
    ...mapState({
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
    }),
  },
  created() {
    this.category_id = this.getCateId();

    if (this.category_id == 0) {
      this.getGroupCategory();
    } else {
      this.getCategory();
    }

    // if (this.$route.query.sc) {
    //   this.onClickSubCate(this.$route.query.sc);
    // } else {
    //   if (this.category_id == 0) {
    //     this.getGroupCategory();
    //   } else {
    //     this.getCategory();
    //   }
    // }
  },

  watch: {
    onChangeCate() {
      this.isLoading = true;

      this.category_id = this.getCateId();

      if (this.category_id == 0) {
        this.getGroupCategory();
      } else {
        this.getCategory();
      }
    },
  },
  methods: {
    getCategory() {
      this.isLoading = true;
      this.subCateId = 0;
      let data = { id: this.category_id, page: 1 };
      this.$store
        .dispatch("portfolio/getPortfolioByIdCategory", data)
        .then((res) => {
          this.portfolios = res.portfolios;
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    onclickCategory(item) {
      this.$router.push(
        `/portfolio-category/${
          this.switchLanguage === "th" ? item.name_th : item.name_en
        }${item.name_th === "รวม" ? "" : "-" + item.id}`
      );

      // let data = { id: item.id, page: 1 };
      // this.isLoading = true;
      // this.$store
      //   .dispatch("portfolio/getPortfolioByIdCategory", data)
      //   .then((res) => {
      //     this.isLoading = false;
      //     if (this.currentRouteName !== "AllPortfolioByCategory") {
      //       this.$router.push(`/portfolio-category/${item.name_th}`);
      //     }
      //   })
      //   .catch((e) => {
      //     this.isLoading = false;
      //   });
    },
    getGroupCategory() {
      this.isLoading = true;

      this.$store
        .dispatch("Common/getGroupCategory")
        .then((res) => {
          this.isLoading = false;
          this.groupCategory = res;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    // onGetAllports() {
    //   let data = { id: 0, page: 1 };
    //   this.isLoading = true;
    //   this.$store
    //     .dispatch("portfolio/getPortfolioByIdCategory", data)
    //     .then((res) => {
    //       this.isLoading = false;
    //       if (this.currentRouteName !== "AllPortfolioByCategory") {
    //         this.$router.push("/portfolio-category/รวม");
    //       }
    //     });
    // },
    viewPortDetail(port) {
      let domain_slug =
        port.profile.mem_info && port.profile.mem_info.domain_name
          ? port.profile.mem_info.domain_name
          : port.profile.profile_id;
      this.$router.push({
        path: `/profile/${domain_slug}/${port.portfolio_id}`,
      });
    },
    onClickSubCate(item) {
      this.isLoading = true;
      this.subCateId = item.id;
      this.btnCate = false;
      let data = {
        page: 1,
        category_id: this.category_id,
        subcategory_id: item.id,
      };
      this.$store
        .dispatch("portfolio/getPortfolioByIdSubCategory", data)
        .then(() => {
          this.isLoading = false;
        });
      // this.$router
      //   .replace(
      //     `/portfolio-category/${this.$route.params.slug}/${
      //       this.switchLanguage === "th" ? item.name_th : item.name_en
      //     }`
      //   )
      //   .catch(() => {});
    },
    onclickSubCategoryAll() {
      this.btnCate = true;
      this.isLoading = true;
      this.subCateId = 0;
      let data = {
        page: 1,
        id: this.category_id,
      };
      this.$store
        .dispatch("portfolio/getPortfolioByIdCategory", data)
        .then(() => {
          this.isLoading = false;
        });

      // this.$router
      //   .replace(`/portfolio-category/${this.$route.params.slug}`)
      //   .catch(() => {});
    },
    getPortBySubcate() {
      this.$store
        .dispatch("portfolio/getPortfolioByIdCategory", data)
        .then(() => {
          this.isLoading = false;
        });
    },
    getPortfolioByIdCategoryMore() {
      let data = {
        id: this.category_id,
        page: this.portfolioArticles.current_page + 1,
      };
      this.btnLoading = true;
      this.$store
        .dispatch("portfolio/getPortfolioByIdCategoryMore", data)
        .then((res) => {
          this.btnLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.btnLoading = false;
        });
    },
    getPortfolioByIdSubCategoryMore() {
      let data = {
        page: this.portfolioArticles.current_page + 1,
        category_id: this.category_id,
        subcategory_id: this.subCateId,
      };
      this.btnLoading = true;
      this.$store
        .dispatch("portfolio/getPortfolioByIdSubCategoryMore", data)
        .then((res) => {
          this.btnLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.btnLoading = false;
        });
    },
    checkVariable(val) {
      if (val) {
        return val;
      } else {
        return "";
      }
    },
    checkName(val) {
      if (val.name_th && val.last_th) {
        if (val.name_th.length > 15) {
          return val.name_th;
        } else {
          return val.name_th + " " + val.last_th;
        }
      } else if (val.name_th && !val.last_th) {
        return val.name_th;
      } else if (val.name_en && val.last_en) {
        if (val.name_en.length > 15) {
          return val.name_en;
        } else {
          return val.name_en + " " + val.last_en;
        }
      } else if (val.name_en && !val.last_en) {
        return val.name_en;
      } else {
        return val.email;
      }
    },
    checkImage(val) {
      if (val) {
        if (val.avatar) {
          return val.avatar;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.on-hover-cate:hover {
  color: #fd5246;
  cursor: pointer;
}

.active-category {
  color: #fd5246;
  /*background-color: #FFFFFF;*/
  /*border-radius: 50%;*/
}

.category {
  border-right-style: solid;
  /*border-left-style: solid;*/
  border-width: 0.5px;
  border-color: #dfdfdf;
}

.row-article {
  display: flex;
  flex-wrap: wrap;
}

.col-article {
  /*flex: 1 0 18%;*/
  /*margin: 5px;*/
  /*height: 50px;*/
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: center;*/
}
</style>
